// Traduções para múltiplos idiomas
export const translations = {
  pt: {
    // Header
    title: "Busca de Códigos SIF",
    subtitle:
      "Digite um código para encontrar SIFs de carnes halal certificadas",

    // Language selector
    languageLabel: "Idioma:",

    // Search
    searchPlaceholder: "Digite um código SIF",
    searching: "🔄 Buscando...",
    clearSearch: "Limpar busca",
    searchButton: "Pesquisar",

    // Results
    resultsFor: "Resultado da busca por",
    resultsCount: "código(s) encontrado(s)",
    noResults: "Nenhum código encontrado para",
    isHalal: "É HALAL",
    notHalal: "NÃO É HALAL",
    halalMessage:
      "Este código foi encontrado em nossa base de dados de estabelecimentos certificados.",
    notHalalMessage:
      "Este código não foi encontrado em nossa base de dados. O produto pode não ser Halal.",
    foundCodes: "Códigos encontrados:",
    clickForDetails: "Clique em um código para ver detalhes",

    // Company info
    companyName: "Empresa",
    address: "Endereço",
    country: "País",
    products: "Produtos",
    certificate: "Certificado",
    recognition: "Reconhecimento",
    certifier: "Certificadora",

    // Help text
    helpTitle: "Tente buscar por:",
    helpSifNumber: 'Número do SIF (ex: "2258", "3941")',
    helpCompleteCode: 'Código completo (ex: "SIF 2258")',
    helpEstablishment:
      'Tipo de estabelecimento (ex: "SENASA", "ESTABELECIMENTO")',

    // Welcome
    welcomeMessage: "👋 Digite um código no campo acima para começar a busca",
    examplesTitle: "Clique em um dos exemplos para testar:",
    moreExamplesTitle: "Ou tente buscar por:",

    // Search tips
    tipNumbers: 'Apenas números: "2258"',
    tipType: 'Tipo: "SIF"',
    tipOrgan: "SIF 2258",

    // Share
    share: "Compartilhar",
    shareApp: "Compartilhar App",
    scanQrCode: "Escaneie o QR Code para acessar o app",
  },

  en: {
    // Header
    title: "SIF Code Search",
    subtitle: "Enter a code to find halal certified meat SIFs",

    // Language selector
    languageLabel: "Language:",

    // Search
    searchPlaceholder: "Enter a SIF code",
    searching: "🔄 Searching...",
    clearSearch: "Clear search",
    searchButton: "Search",

    // Results
    resultsFor: "Search result for",
    resultsCount: "code(s) found",
    noResults: "No code found for",
    isHalal: "IT'S HALAL",
    notHalal: "NOT HALAL",
    halalMessage:
      "This code was found in our database of certified establishments.",
    notHalalMessage:
      "This code was not found in our database. The product may not be Halal.",
    foundCodes: "Codes found:",
    clickForDetails: "Click on a code to see details",

    // Company info
    companyName: "Company",
    address: "Address",
    country: "Country",
    products: "Products",
    certificate: "Certificate",
    recognition: "Recognition",
    certifier: "Certifier",

    // Help text
    helpTitle: "Try searching for:",
    helpSifNumber: 'SIF number (e.g: "2258", "3941")',
    helpCompleteCode: 'Complete code (e.g: "SIF 2258")',
    helpEstablishment: 'Type: "SIF"',

    // Welcome
    welcomeMessage: "👋 Enter a code in the field above to start searching",
    examplesTitle: "Click on one of the examples to test:",
    moreExamplesTitle: "Or try searching for:",

    // Search tips
    tipNumbers: 'Numbers only: "2258"',
    tipType: 'Type: "SIF"',
    tipOrgan: 'Example: "SIF 3941"',

    // Share
    share: "Share",
    shareApp: "Share App",
    scanQrCode: "Scan the QR Code to access the app",
  },

  ar: {
    // Header
    title: "البحث عن رموز SIF",
    subtitle: "أدخل رمزاً للعثور على رموز SIF للحوم الحلال المعتمدة",

    // Language selector
    languageLabel: "اللغة:",

    // Search
    searchPlaceholder: "أدخل رمز SIF",
    searching: "🔄 جاري البحث...،",
    clearSearch: "مسح البحث",
    searchButton: "بحث",

    // Results
    resultsFor: "نتيجة البحث عن",
    resultsCount: "رمز موجود",
    noResults: "لم يتم العثور على رمز لـ",
    isHalal: " حلال",
    notHalal: " ليس حلال",
    halalMessage:
      "تم العثور على هذا الرمز في قاعدة بياناتنا للمؤسسات المعتمدة.",
    notHalalMessage:
      "لم يتم العثور على هذا الرمز في قاعدة بياناتنا. قد لا يكون المنتج حلالاً.",
    foundCodes: "الرموز الموجودة:",
    clickForDetails: "انقر على رمز لرؤية التفاصيل",

    // Company info
    companyName: "الشركة",
    address: "العنوان",
    country: "البلد",
    products: "المنتجات",
    certificate: "الشهادة",
    recognition: "الاعتراف",
    certifier: "جهة الاعتماد",

    // Help text
    helpTitle: "جرب البحث عن:",
    helpSifNumber: 'رقم SIF (مثال: "2258"، "3941")',
    helpCompleteCode: 'الرمز الكامل (مثال: "SIF 2258")',
    helpEstablishment: 'النوع: "SIF"',

    // Welcome
    welcomeMessage: "👋 أدخل رمزاً في الحقل أعلاه لبدء البحث",
    examplesTitle: "انقر على أحد الأمثلة للاختبار:",
    moreExamplesTitle: "أو جرب البحث عن:",

    // Search tips
    tipNumbers: 'أرقام فقط: "2258"',
    tipType: 'النوع: "SIF"',
    tipOrgan: 'مثال: "SIF 3941"',

    // Share
    share: "مشاركة",
    shareApp: "مشاركة التطبيق",
    scanQrCode: "امسح رمز QR للوصول إلى التطبيق",
  },
};

export const languages = [
  { code: "pt", name: "Português", flag: "🇧🇷" },
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "ar", name: "العربية", flag: "🇸🇦" },
];
